import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { clientSchema } from './schemas';
import { clientsQueryOptions } from './useClients';

export const useRefreshVatInformation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (clientId: number) => {
      const { data: client } = await fetchJson(`/clients/${clientId}/refresh-vat-information`, {
        method: 'POST',
        schema: apiResourceSchema(clientSchema),
      });

      return client;
    },
    onSuccess: (updatedClient) => {
      queryClient.setQueryData(clientsQueryOptions.queryKey, (clients) =>
        (clients ?? []).map((client) => (client.id === updatedClient.id ? updatedClient : client)),
      );

      return queryClient.invalidateQueries({ queryKey: QueryKeys.clients.index });
    },
  });
};
